export default __webpack_public_path__ + "static/media/kyc_ghost.0745d64b.svg";